import {NgModule} from '@angular/core';
import {ModelePlatResolverService} from './modele-plat-resolver.service';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {CoreModule} from '../core/core.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GestionConditionnementsRootComponent} from './gestionconditionnements.component';
import {GestionConditionnementsRoutingModule} from './gestionconditionnements-routing.module';
import {ParametrageConditionnementModelesPlatsComponent} from './modeles-plats/dialog/parametrage/mp-parametrage.component';
import {PlatsComponent} from './modeles-plats/dialog/plats/mp-plats.component';
import {ModelePlatComponent} from './modeles-plats/dialog/modele-plat.component';
import {
    DxButtonGroupModule, DxButtonModule,
    DxCheckBoxModule,
    DxDataGridModule, DxDateBoxModule,
    DxDropDownBoxModule, DxListModule, DxLoadIndicatorModule, DxLoadPanelModule, DxLookupModule, DxMultiViewModule,
    DxNumberBoxModule,
    DxPopupModule, DxRadioGroupModule, DxScrollViewModule,
    DxSelectBoxModule, DxTabPanelModule, DxTabsModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxTreeListModule,
    DxTreeViewModule
} from 'devextreme-angular';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {DropdownModule} from 'primeng/dropdown';

import {CardModule} from 'primeng/card';
import {PanelModule} from 'primeng/panel';
import {ListboxModule} from 'primeng/listbox';
import {TabMenuModule} from 'primeng/tabmenu';
import {DialogModule} from 'primeng/dialog';

import {ModelesPlatsComponent} from './modeles-plats/modeles-plats.component';
import {InputTextModule} from "primeng/inputtext";
import {ModelePlatIdentiteComponent} from "./modeles-plats/dialog/fiche-identite/mp-identite.component";
import {CheckBoxComponent} from "../shared/ui/check-box/check-box.component";
import {ModelePlatAddConditionnementVarianteDeclinaison} from "./modeles-plats/dialog/parametrage/dialog/mp-add-cv-decli.component";
import {ParametrageConditionnementModelesPlcComponent} from "./modeles-plc/dialog/parametrage/mp-parametrage.component";
import {PointsLivraisonComponent} from "./modeles-plc/dialog/points-livraison/mp-points-livraison.component";
import {ModelePlcIdentiteComponent} from "./modeles-plc/dialog/fiche-identite/mp-identite.component";
import {ModelesPlcComponent} from "./modeles-plc/modeles-plc.component";
import {ModelePlcComponent} from "./modeles-plc/dialog/modele-plc.component";
import {ModelePlcResolverService} from "./modele-plc-resolver.service";
import {ModelePlcRowParametrage} from "./modeles-plc/dialog/parametrage/dialog/mp-row-parametrage.component";
import {PreparationConditionnementComponent} from "./preparation/preparation-conditionnement.component";
import {PreparationCalculConditionnementComponent} from "./preparation/calcul/preparation-calcul-conditionnement.component";
import {PreparationConditionnementResolverService} from "./preparation-conditionnement-resolver.service";
import {PreparationCalculConditionnementDetailsComponent} from "./preparation/calcul/details/preparation-calcul-conditionnement-details.component";
import {MenuModule} from "primeng/menu";
import {DialogAjoutMcpPlatsComponent} from "./modeles-plats/dialog/plats/dialog/dialog-ajout-mcp-plats.component";
import {DialogAjoutMcplcPlcComponent} from "./modeles-plc/dialog/points-livraison/dialog/dialog-ajout-mcplc-plc.component";
import {PrintSettingsEditionsConditionnementComponent} from "./preparation/calcul/print-settings/print-settings-editions-conditionnement.component";
import {TooltipModule} from "primeng/tooltip";
import {RegroupementPlatComponent} from "./regroupement-plat-plc/regroupement-plat.component";
import {
  RegroupementPlatDialogComponent
} from "./regroupement-plat-plc/dialog/regroupement-plat-dialog.component";
import {
  RegroupementPlatDialogPlatsComponent
} from "./regroupement-plat-plc/dialog/plat/regroupement-plat-dialog-plats.component";
import {
  RegroupementPlatDialogPlcComponent
} from "./regroupement-plat-plc/dialog/plc/regroupement-plat-dialog-plc.component";
import {
  RegroupementPlatDialogFicheTechniqueComponent
} from "./regroupement-plat-plc/dialog/fiche-technique/regroupement-plat-dialog-fiche-technique.component";
import {
  RegroupementPlatPlcAddDialogComponent
} from "./regroupement-plat-plc/dialog/plc/dialog/regroupement-plat-plc-add-dialog.component";
import {
  RegroupementPlatErrorsComponent
} from "./regroupement-plat-plc/dialog/errors/regroupement-plat-errors.component";
import {DisplayCalculConditionnementErreurComponent} from "./preparation/calcul/errors/display-calcul-conditionnement-erreur.component";
import {ParametreCalculConditionnementGlobalDialogComponent} from "./modeles-plats/parametre_calcul_conditionnement_global_dialog/parametre-calcul-conditionnement-global-dialog.component";
import {ParametreCalculConditionnementComponent} from "./parametre_calcul_conditionnement/parametre-calcul-conditionnement.component";

@NgModule({
    imports: [
        CommonModule,
        GestionConditionnementsRoutingModule,
        SharedModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,


        CardModule,
        PanelModule,
        ListboxModule,
        TabMenuModule,
        DialogModule,


        DxTreeListModule,
        DxDataGridModule,
        OverlayPanelModule,
        DropdownModule,
        DxSelectBoxModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxTextBoxModule,
        InputTextModule,
        MenuModule,
        DropdownModule,
        DxTagBoxModule,
        DxPopupModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxToolbarModule,
        DxLookupModule,
        DxListModule,
        DxTabPanelModule,
        DxCheckBoxModule,
        CheckBoxComponent,
        DxRadioGroupModule,
        DxLoadIndicatorModule,
        TooltipModule,
        DxButtonGroupModule,
        DxLoadPanelModule,
        DxButtonModule,
        DxTabsModule,
        DxMultiViewModule,
        DxScrollViewModule,
        DxDateBoxModule,
    ],
  declarations: [
    GestionConditionnementsRootComponent,
    ParametrageConditionnementModelesPlatsComponent,
    PlatsComponent,
    ModelePlatComponent,
    ModelesPlatsComponent,
    ModelePlatIdentiteComponent,
    ModelePlatAddConditionnementVarianteDeclinaison,
    ParametrageConditionnementModelesPlcComponent,
    PointsLivraisonComponent,
    ModelePlcIdentiteComponent,
    ModelesPlcComponent,
    ModelePlcComponent,
    ModelePlcRowParametrage,
    PreparationConditionnementComponent,
    PreparationCalculConditionnementComponent,
    PreparationCalculConditionnementDetailsComponent,
    DialogAjoutMcpPlatsComponent,
    DialogAjoutMcplcPlcComponent,
    RegroupementPlatComponent,
    RegroupementPlatDialogComponent,
    RegroupementPlatDialogPlatsComponent,
    RegroupementPlatDialogPlcComponent,
    RegroupementPlatDialogFicheTechniqueComponent,
    RegroupementPlatPlcAddDialogComponent,
    RegroupementPlatErrorsComponent,
    DisplayCalculConditionnementErreurComponent,
    PrintSettingsEditionsConditionnementComponent,
    ParametreCalculConditionnementComponent,
    ParametreCalculConditionnementGlobalDialogComponent
  ],
  exports: [
    PrintSettingsEditionsConditionnementComponent,
    DisplayCalculConditionnementErreurComponent,
  ],
  providers: [ModelePlatResolverService, ModelePlcResolverService, PreparationConditionnementResolverService]
})
export class GestionConditionnementsModule {
}
